import React, { useEffect, useState } from "react";
function Notification({
  notifications
}) {
  const [visibleNotifications, setVisibleNotifications] = useState([]);
  useEffect(() => {
    if (notifications.length > 0) {
      const latest = notifications[0];
      setVisibleNotifications(prev => [latest, ...prev]);
      const timer = setTimeout(() => {
        setVisibleNotifications(prev => prev.filter(item => item !== latest));
      }, 20000);
      return () => clearTimeout(timer);
    }
  }, [notifications]);
  return <div style={{
    position: "fixed",
    top: "20px",
    right: "20px",
    zIndex: 9999
  }}>
      {visibleNotifications.map((item, index) => <div key={index} style={{
      width: "320px",
      marginBottom: "10px",
      background: item.type === "service" ? "#198754" : "#0d6efd",
      color: "#fff",
      borderRadius: "12px",
      padding: "15px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
      animation: "slideIn 0.3s ease"
    }}>
          <div className="d-flex justify-content-between">
            <strong>
              {item.type === "service" ? "🚀 New Service" : "👑 New Plan"}
            </strong>
          </div>

          <div className="mt-2">
            {item.message}
          </div>

         
        </div>)}

      <style>
        {`
          @keyframes slideIn {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
        `}
      </style>
    </div>;
}
export default Notification;
